import { render, staticRenderFns } from "./visitorsNotice.vue?vue&type=template&id=088746de&scoped=true&"
import script from "./visitorsNotice.vue?vue&type=script&lang=js&"
export * from "./visitorsNotice.vue?vue&type=script&lang=js&"
import style0 from "./visitorsNotice.vue?vue&type=style&index=0&id=088746de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088746de",
  null
  
)

export default component.exports